import React, { Component } from 'react';
import styled from 'styled-components';
import vhCheck from 'vh-check';
import TextContent from './TextContent';
import ImageContent from './ImageContent';

const Container = styled.div`
    display: flex;
    flex-flow: row nowrap;
    position: relative;
    /* border: 1px dashed red; */
`;

class Work extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vh: 0,
      slideNumber: 0,
    };
    this.pageSplitTimes = 1.4;
    this.lastScrollTop = 0;
    this.scrollDirectionDown = true;
    this.handleScroll = this.handleScroll.bind(this);
    this.workDetails = [
      {
        number: '',
        projectName: '',
        projectDesc: '',
        projectUrl: '',
        projectType: '',
        roles: [''],
      },
      {
        number: '01',
        projectName: 'Forever Collections Art',
        projectUrl: 'https://www.forevercollection.art',
        projectDesc: "The NFT marketplace for museums. Seamlessly connect cultural institutions with global audiences, preserving masterpieces as NFTs on the blockchain. The platform, inspired by OpenSea's Seaport, boasts a user-friendly Next.js frontend.",
        projectType: 'WEB APP',
        roles: ['NextJS', 'TypeScript', 'Solidity'],
      },
      {
        number: '02',
        projectName: 'CION.FI',
        projectDesc: 'Experience infinite liquidity and decentralized power on the Canto Network, where trading reaches new heights in perpetuity.',
        projectType: 'WEB APP',
        roles: ['ReactJS', 'JavaScript', 'Solidity'],
      },
      {
        number: '03',
        projectName: 'MINTY.ART',
        projectDesc: 'Discover a curated paradise where verified artists thrive, minting and trading their exclusive masterpieces in an NFT marketplace of true creative excellence.',
        projectUrl: 'https://www.minty.art',
        projectType: 'WEB APP',
        roles: ['NextJS', 'TypeScript', 'Solidity'],
      },
      {
        number: '',
        projectName: '',
        projectDesc: '',
        projectUrl: '',
        projectType: '',
        roles: [''],
      },
    ];
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    const vhDiff = vhCheck().offset;
    this.setState(
      {
        vh: Math.round(
          (window.document.documentElement.clientHeight + vhDiff) * this.pageSplitTimes,
        ),
      },
    );
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    const { body, documentElement } = event.srcElement;
    const { vh, slideNumber } = this.state;
    const scrollDistance = Math.max(body.scrollTop, documentElement.scrollTop);
    if (scrollDistance > this.lastScrollTop) {
      this.scrollDirectionDown = true;
    } else {
      this.scrollDirectionDown = false;
    }
    this.lastScrollTop = scrollDistance;
    // console.log(scrollDistance);

    if (Math.floor(scrollDistance / vh) !== slideNumber
      && slideNumber < this.workDetails.length - 1) {
      this.setState({ slideNumber: Math.floor(scrollDistance / vh) });
    } else if (slideNumber === this.workDetails.length - 1
      && (Math.floor(scrollDistance / vh) < slideNumber)) {
      this.setState({ slideNumber: Math.floor(scrollDistance / vh) });
    }
  }

  changeTextContentBasedOnScroll() {
    const { slideNumber } = this.state;
    const refresh = true;
    return (
      <TextContent
        number={this.workDetails[slideNumber].number}
        projectName={this.workDetails[slideNumber].projectName}
        projectDesc={this.workDetails[slideNumber].projectDesc}
        projectType={this.workDetails[slideNumber].projectType}
        projectUrl={this.workDetails[slideNumber].projectUrl}
        roles={this.workDetails[slideNumber].roles}
        refreshToggle={refresh}
      />
    );
  }

  render() {
    return (
      <Container>
        {this.changeTextContentBasedOnScroll()}
        <ImageContent pageSplitTimes={this.pageSplitTimes} />
      </Container>
    );
  }
}

export default Work;
